/**
 * @file: 快捷键处理
 * @author: xiaolong.huang@dmall.com
 */

import HotKey from '../../utils/hotkey';
import CEvent from '../../utils/event';
import WhiteList from './whiteList';

class Shortcutkey {
    shortcutkeyEvent: any = new CEvent();

    constructor() {
        this.init();
    }

    private init(): void {
        HotKey.init();
        this.bindShortcutkey();
    }

    // 监听快捷键
    private bindShortcutkey(): void {
        // 空格键按下
        HotKey.on('keydown', 'space', (event: Event): void => {
            this.shortcutkeyEvent.fire('keydown+space', {event: event});
        });

        // e键按下
        HotKey.on('keydown', 'e', (event: JQuery.KeyDownEvent): void => {
            this.shortcutkeyEvent.fire('press+e', {event: event});
        });

        // e键抬起
        HotKey.on('keyup', 'e', (event: JQuery.KeyUpEvent): void => {
            this.shortcutkeyEvent.fire('press+up+e', {event: event});
        });

        // 保存
        HotKey.on('keydown', 'ctrl+s', (event: JQuery.KeyUpEvent): void => {
            this.shortcutkeyEvent.fire('ctrl+s', {event: event});
        });
        HotKey.on('keydown', 'command+s', (event: JQuery.KeyDownEvent): void => {
            this.shortcutkeyEvent.fire('command+s', {event: event});
        });

        // ctrl + c
        HotKey.on('keydown', 'ctrl+c', (event: Event): void => {
            this.shortcutkeyEvent.fire('ctrl+c', {event: event});
        });
        HotKey.on('keydown', 'command+c', (event: Event): void => {
            this.shortcutkeyEvent.fire('command+c', {event: event});
        });

        // f5
        HotKey.on('keyup', 'f5', (event: Event): void => {
            this.shortcutkeyEvent.fire('f5', {event: event});
        });
        HotKey.on('keydown', 'command+r', (event: Event): void => {
            this.shortcutkeyEvent.fire('command+r', {event: event});
        });
        HotKey.on('keydown', 'ctrl+r', (event: Event): void => {
            this.shortcutkeyEvent.fire('ctrl+r', {event: event});
        });

        // ctrl + x
        HotKey.on('keydown', 'ctrl+x', (event: Event): void => {
            this.shortcutkeyEvent.fire('ctrl+x', {event: event});
        });
        HotKey.on('keydown', 'command+x', (event: Event): void => {
            this.shortcutkeyEvent.fire('command+x', {event: event});
        });

        // ctrl + shift + g
        HotKey.on('keydown', 'ctrl+shift+g', (event: Event): void => {
            this.shortcutkeyEvent.fire('ctrl+shift+g', {event: event});
        });
        
        // ctrl + shift + l
        HotKey.on('keydown', 'ctrl+shift+l', (event: Event): void => {
            this.shortcutkeyEvent.fire('ctrl+shift+l', {event: event});
        });

        // ctrl + shift + r
        HotKey.on('keydown', 'ctrl+shift+r', (event: Event): void => {
            this.shortcutkeyEvent.fire('ctrl+shift+r', {event: event});
        });

        // ctrl + k
        HotKey.on('keydown', 'ctrl+k', (event: Event): void => {
            this.shortcutkeyEvent.fire('ctrl+k', {event: event});
        });
        HotKey.on('keydown', 'command+k', (event: Event): void => {
            this.shortcutkeyEvent.fire('command+k', {event: event});
        });

        // ctrl + z
        HotKey.on('keydown', 'ctrl+z', (event: Event): void => {
            this.shortcutkeyEvent.fire('ctrl+z', {event: event});
        });
        HotKey.on('keydown', 'command+z', (event: Event): void => {
            this.shortcutkeyEvent.fire('command+z', {event: event});
        });

        // ctrl + l
        HotKey.on('keydown', 'ctrl+l', (event: Event): void => {
            this.shortcutkeyEvent.fire('ctrl+l', {event: event});
        });
        HotKey.on('keydown', 'command+l', (event: Event): void => {
            this.shortcutkeyEvent.fire('command+l', {event: event});
        });

        HotKey.on('keydown', 'ctrl+number', (event: Event): void => {
            this.shortcutkeyEvent.fire('ctrl+number', {event: event});
        });
        HotKey.on('keydown', 'command+number', (event: Event): void => {
            this.shortcutkeyEvent.fire('command+number', {event: event});
        });

        // ctrl + d
        HotKey.on('keydown', 'ctrl+d', (event: Event): void => {
            this.shortcutkeyEvent.fire('ctrl+d', {event: event});
        });
        HotKey.on('keydown', 'command+d', (event: Event): void => {
            this.shortcutkeyEvent.fire('command+d', {event: event});
        });

        // ctrl + v
        HotKey.on('keydown', 'ctrl+v', (event: Event): void => {
            this.shortcutkeyEvent.fire('ctrl+v', {event: event});
        });
        HotKey.on('keydown', 'command+v', (event: Event): void => {
            this.shortcutkeyEvent.fire('command+v', {event: event});
        });

        HotKey.on('keydown', 'ctrl+backspace', (event: Event): void => {
            this.shortcutkeyEvent.fire('ctrl+backspace', {event: event});
        });
        HotKey.on('keydown', 'ctrl+del', (event: Event): void => {
            this.shortcutkeyEvent.fire('ctrl+del', {event: event});
        });

        // 删除键
        HotKey.on('keyup', 'backspace', (event: Event): void => {
            this.shortcutkeyEvent.fire('press+backspace', {event: event});
        });
        HotKey.on('keyup', 'del', (event: Event): void => {
            this.shortcutkeyEvent.fire('press+del', {event: event});
        });

        HotKey.on('keyup', 'esc', (event: Event): void => {
            this.shortcutkeyEvent.fire('press+esc', {event: event});
        });

        // 数字键
        HotKey.on('keyup', 'number', (event: Event): void => {
            this.shortcutkeyEvent.fire('press+number', {event: event});
        });

        // ctrl+i
        HotKey.on('keydown', 'ctrl+i', (event: Event): void => {
            this.shortcutkeyEvent.fire('ctrl+i', {event: event});
        });
        HotKey.on('keydown', 'command+i', (event: Event): void => {
            this.shortcutkeyEvent.fire('command+i', {event: event});
        });
        HotKey.on('keyup', 'space', (event: Event): void => {
            this.shortcutkeyEvent.fire('keyup+space', {event: event});
        });
        HotKey.on('keyup', (event: Event): void => {
            this.shortcutkeyEvent.fire('keyup', {event: event});
        });

        // ctrl+a 全选
        HotKey.on('keydown', 'ctrl+a', (event: Event): void => {
            this.shortcutkeyEvent.fire('ctrl+a', {event: event});
        });
        HotKey.on('keydown', 'command+a', (event: Event): void => {
            this.shortcutkeyEvent.fire('command+a', {event: event});
        });

        // ctrl+g
        HotKey.on('keydown', 'ctrl+g', (event: Event): void => {
            this.shortcutkeyEvent.fire('ctrl+g', {event: event});
        });
        HotKey.on('keydown', 'command+g', (event: Event): void => {
            this.shortcutkeyEvent.fire('command+g', {event: event});
        });

        // 移动键
        HotKey.on('keydown', 'w', (event: Event): void => {
            this.shortcutkeyEvent.fire('press+w', {event: event});
        });
        HotKey.on('keydown', 's', (event: Event): void => {
            this.shortcutkeyEvent.fire('press+s', {event: event});
        });
        HotKey.on('keydown', 'a', (event: Event): void => {
            this.shortcutkeyEvent.fire('press+a', {event: event});
        });
        HotKey.on('keydown', 'd', (event: Event): void => {
            this.shortcutkeyEvent.fire('press+d', {event: event});
        });

        HotKey.on('keyup', '/', (event: Event): void => {
            this.shortcutkeyEvent.fire('/', {event: event});
        });

        HotKey.on('keyup', 'r', (event: Event): void => {
            this.shortcutkeyEvent.fire('keyup+r', {event: event});
        });

        // 应用退出到后台
        HotKey.on('blur', (event: Event): void => {
            this.shortcutkeyEvent.fire('appToBackground', {event: event});
        });

        // 鼠标左键按下
        HotKey.on('mousedown', 'mouseleft', (event: Event): any => {
            if (this.isDisable(event)) {
                return;
            }
            this.shortcutkeyEvent.fire('mousedown+mouseleft', {event: event});
        });

        // 鼠标按下, 在画布外触发
        HotKey.on('mousedown', (event: Event): any => {
            if (!this.notInStage(event)) {
                return;
            }
            this.shortcutkeyEvent.fire('mousedown+outsideofstage', {event: event});
        });

        // 鼠标左键抬起
        HotKey.on('mouseup', 'mouseleft', (event: Event): void => {
            if (this.isDisable(event)) {
                return;
            }
            this.shortcutkeyEvent.fire('mouseup+mouseleft', {event: event});
        });

        // 鼠标右键按下
        HotKey.on('mousedown', 'mouseright', (event: Event): void => {
            if (this.isDisable(event)) {
                return;
            }
            this.shortcutkeyEvent.fire('mousedown+mouseright', {event: event});
        });

        // 鼠标右键抬起
        HotKey.on('mouseup', 'mouseright', (event: Event): void => {
            if (this.isDisable(event)) {
                return;
            }
            this.shortcutkeyEvent.fire('mouseup+mouseright', {event: event});
        });

        // 空格加鼠标左键
        HotKey.on('mousedown', 'space+mouseleft', (event: Event): void => {
            if (this.isDisable(event)) {
                return;
            }
            this.shortcutkeyEvent.fire('mousedown+space+mouseleft', {event: event});
        });

        HotKey.on('mousedown', 'c+mouseleft', (event: JQuery.MouseDownEvent): void => {
            if (this.isDisable(event)) {
                return;
            }
            this.shortcutkeyEvent.fire('mousedown+c+mouseleft', {event: event});
        });

        // 鼠标中键
        HotKey.on('mousedown', 'mousecenter', (event: Event): boolean => {
            if (this.isDisable(event)) {
                return false;
            }
            this.shortcutkeyEvent.fire('mousedown+mousecenter', {event: event});
            return false;
        });

        // shift + 鼠标左键
        HotKey.on('mousedown', 'shift+mouseleft', (event: Event): boolean => {
            if (this.isDisable(event)) {
                return;
            }
            this.shortcutkeyEvent.fire('mousedown+shift+mouseleft', {event: event});
            return false;
        });

        // 空格 + 鼠标拖动
        HotKey.on('mousemove', 'space+mouseleft', (event: Event): boolean => {
            this.shortcutkeyEvent.fire('mousemove+space+mouseleft', {event: event});
            return false;
        });

        // 鼠标中键按下拖动
        HotKey.on('mousemove', 'mousecenter', (event: Event): boolean => {
            this.shortcutkeyEvent.fire('mousemove+mousecenter', {event: event});
            return false;
        });

        // 空格 + 鼠标左键抬起
        HotKey.on('mouseup', 'space+mouseleft', (event: Event): void => {
            this.shortcutkeyEvent.fire('mouseup+space+mouseleft', {event: event});
        });

        // 鼠标中键抬起
        HotKey.on('mouseup', 'mousecenter', (event: Event): boolean => {
            this.shortcutkeyEvent.fire('mouseup+mousecenter', {event: event});
            return false;
        });

        // 双击
        HotKey.on('dblclick', (event: Event): void => {
            if (this.isDisable(event)) {
                return;
            }
            this.shortcutkeyEvent.fire('dblclick', {event: event});
        });

        // ctrl + 鼠标左键
        HotKey.on('mousedown', 'ctrl+mouseleft', (event: Event): boolean => {
            if (this.isDisable(event)) {
                return false;
            }
            this.shortcutkeyEvent.fire('ctrl+mouseleft', {event: event});
            return false;
        });

        // command + 鼠标左键
        HotKey.on('mousedown', 'command+mouseleft', (event: Event): boolean => {
            if (this.isDisable(event)) {
                return false;
            }
            this.shortcutkeyEvent.fire('command+mouseleft', {event: event});
            return false;
        });

        // 鼠标按下
        HotKey.on('mousedown', (event: Event): boolean => {
            if (this.isDisable(event)) {
                return;
            }

            this.shortcutkeyEvent.fire('mousedown', {event: event});
        });

        // 鼠标抬起
        HotKey.on('mouseup', (event: Event): void => {
            this.shortcutkeyEvent.fire('mouseup', {event: event});
        });

        // 鼠标中键滚动
        HotKey.on('mousewheel', 'mousecenter', (event: Event): boolean => {
            if (this.isDisable(event)) {
                return;
            }
            this.shortcutkeyEvent.fire('mousewheel+mousecenter', {event: event});
        });

        // 鼠标右键
        HotKey.on('contextmenu', (ev): boolean => {
            if (this.isDisable(ev)) {
                return false;
            }

            this.shortcutkeyEvent.fire('contextmenu', {event: ev});

            return false;
        });
    }

    private isDisable(ev): boolean {
        return this.notInStage(ev);
    }

    private notInStage(ev): boolean {
        let $stage: JQuery<HTMLElement> = $(ev.target).closest('.shelvesbuild-e-sketchpad');

        return $stage.length === 0;
    }

    destroy(): void {
        this.shortcutkeyEvent.clearAll();
    }

    fire(shortcutkey: string, params: FreeObjMap): void {
        this.shortcutkeyEvent.fire(shortcutkey, params);
    }

    on(params) {
        this.shortcutkeyEvent.addFilter('on', function(eventName: string) {
            if (WhiteList.indexOf(eventName) < 0) {
                return false;
            }
        });
        this.shortcutkeyEvent.on(params.keyName, (shortcutkeyParams: FreeObjMap) => {
            params.callback && params.callback(shortcutkeyParams.event);
        });
    }
}

let shortcutkey;

function init(): void {
    if (!shortcutkey) {
        shortcutkey = new Shortcutkey();
    }
}

export default {
    init,
    destroy: () => {
        shortcutkey && shortcutkey.destroy();
    },
    fire: (...arg) => {
        shortcutkey.fire(...arg);
    },
    on: (...arg) => {
        shortcutkey.on(...arg);
    }
};
